"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getPrivacyPortalUrl = void 0;
function getPrivacyPortalUrl(newsroom, locale, options) {
    const { email, action = 'subscribe' } = options || {};
    const url = new URL(`/${locale.toUrlSlug()}/newsroom/${newsroom.uuid}/${action}`, 'https://privacy.prezly.com');
    if (email) {
        url.searchParams.append('email', email);
    }
    return url.toString();
}
exports.getPrivacyPortalUrl = getPrivacyPortalUrl;
//# sourceMappingURL=getPrivacyPortalUrl.js.map